<template>
  <div class="asc-analytic-form-header">
    <section class="asc-analytic-form-header--row1">
      <asc-textarea-input
        v-model="name"
        class="asc-analytic-form-header--row1-module"
        label="Analytic Module Display Name"
        :rows="1"
        :max-length="255"
        flat
        dense
        auto-grow
        spellcheck="false"
      ></asc-textarea-input>

      <asc-autocomplete-selector
        v-model="componentId"
        class="asc-analytic-form-header--row1-component"
        label="Component"
        :items="componentsOptions"
        short
        dense
        no-array
      ></asc-autocomplete-selector>
    </section>

    <section class="asc-analytic-form-header--description">
      <asc-textarea-input
        v-model="description"
        label="Module Description"
      ></asc-textarea-input>
    </section>

    <section class="asc-analytic-form-header--airlines">
      <asc-label
        size="md"
        value="Externally visualized for airline(s):"
      ></asc-label>
      <asc-autocomplete-selector
        v-model="airlineIds"
        class="asc-analytic-form-header--airlines-dropdown"
        :items="airlinesOptions"
        display-clear
        component-type="multiple"
        dense
        short
      ></asc-autocomplete-selector>
    </section>
  </div>
</template>

<script>
import AscAutocompleteSelector from './AscAutocompleteSelector'
import AscTextareaInput from '@/components/atoms/AscTextareaInput'
import AscLabel from '@/components/atoms/AscLabel'

export default {
  name: 'AscAnalyticDialogHeader',

  components: {
    AscAutocompleteSelector,
    AscTextareaInput,
    AscLabel,
  },

  props: {
    analyticDetails: {
      type: Object,
      default: () => {},
    },
    components: {
      type: Array,
      required: true,
      default: () => [],
    },
    airlines: {
      type: Array,
      required: true,
      default: () => [],
    },
  },

  computed: {
    name: {
      get() {
        return this.analyticDetails.displayName
      },
      set(val) {
        this.updateObject('displayName', val)
      },
    },
    description: {
      get() {
        return this.analyticDetails.description
      },
      set(val) {
        this.updateObject('description', val)
      },
    },
    componentId: {
      get() {
        return this.analyticDetails.componentId
      },
      set(val) {
        this.updateObject('componentId', val)
      },
    },
    airlineIds: {
      get() {
        return this.analyticDetails.airlineIds
      },
      set(val) {
        this.updateObject('airlineIds', val)
      },
    },
    componentsOptions() {
      if (this.components) {
        const duplicateSysName = []
        const duplicates = this.components
          .filter((item, index, array) => {
            const c = array.map(item => item.name)
            const i = array.findIndex(
              val =>
                val.name === item.name && val.systemName === item.systemName,
            )
            if (i >= 0 && i !== index) {
              duplicateSysName.push(item.name)
            }
            return index !== c.indexOf(item.name)
          })
          .map(item => item.name)
        return this.components.map(function (item) {
          let compName = item.name
          if (
            duplicates.includes(item.name) &&
            !duplicateSysName.includes(item.name)
          ) {
            compName = item.name + ` (${item.systemName})`
          } else if (
            duplicates.includes(item.name) &&
            duplicateSysName.includes(item.name)
          ) {
            compName = item.name + ` (${item.systemName} - ${item.id})`
          }
          return {
            text: compName,
            value: item.id,
          }
        })
      }
      return []
    },
    airlinesOptions() {
      if (this.airlines) {
        return this.airlines.map(item => ({
          text: item.name,
          value: item.id,
        }))
      }
      return []
    },
  },

  methods: {
    updateObject(key, value) {
      const item = {
        key,
        value,
      }
      this.$emit('update-header', item)
    },
  },
}
</script>

<style lang="scss">
.asc-analytic-form-header {
  &--row1 {
    display: flex;
    justify-content: space-between;

    &-module {
      width: 55%;
      margin-top: 8px;
    }

    &-component {
      width: 40%;
    }
  }

  &--description {
    margin-top: 10px;
  }

  &--airlines {
    display: flex;
    height: 50px;

    &-dropdown {
      width: 50%;
      padding-left: 15px;
    }
  }
}

// prettier-ignore
.asc-analytic-form-description {
  margin-top: 20px;
}
</style>
